// extracted by mini-css-extract-plugin
module.exports = {"dueDateWrapper":"DueDateDisplay_dueDateWrapper__SRaey","editIcon":"DueDateDisplay_editIcon__rE2HY"};